module.exports = __webpack_public_path__ + "school/img/zhaosheng.26a863e6.jpg";